module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_c('nav', {
    staticClass: "sidebar-nav"
  }, [_c('ul', {
    staticClass: "nav"
  }, [(_vm.user.hasPermission('order.view.*')) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/orders'
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v(" Заказы")])], 1) : _vm._e(), _vm._v(" "), (_vm.user.isAdmin) ? _c('li', {
    staticClass: "nav-title"
  }, [_vm._v("\n        Админ центр\n      ")]) : _vm._e(), _vm._v(" "), (_vm.user.hasPermission('user.view.*')) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/admin/users'
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" Пользователи")])], 1) : _vm._e(), _vm._v(" "), (_vm.user.hasPermission('techcenter.view.*')) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/techcenters'
    }
  }, [_c('i', {
    staticClass: "fa fa-car"
  }), _vm._v(" Техцентры")])], 1) : _vm._e(), _vm._v(" "), (_vm.user.hasPermission('city.view')) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/admin/cities'
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" Города")])], 1) : _vm._e(), _vm._v(" "), (_vm.user.hasPermission('company.view.*')) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/admin/companies'
    }
  }, [_c('i', {
    staticClass: "fa fa-building"
  }), _vm._v(" Компании")])], 1) : _vm._e(), _vm._v(" "), (_vm.user.hasPermission('role.view')) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/admin/roles'
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" Роли")])], 1) : _vm._e(), _vm._v(" "), (_vm.user.hasPermission('pbx.listen.all')) ? _c('li', {
    staticClass: "nav-title"
  }, [_vm._v("\n        Телефония\n      ")]) : _vm._e(), _vm._v(" "), (_vm.user.hasPermission('pbx.virtualNumbers.control')) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/admin/pbx/virtual-numbers'
    }
  }, [_c('i', {
    staticClass: "icon-call-out icons"
  }), _vm._v(" Виртуальные номера")])], 1) : _vm._e(), _vm._v(" "), (_vm.user.isAdmin) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/admin/custom-fields'
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Кастомные поля")])], 1) : _vm._e(), _vm._v(" "), (_vm.user.isAdmin) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/admin/statuses'
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Статусы")])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/help'
    }
  }, [_c('i', {
    staticClass: "fa fa-question"
  }), _vm._v(" Помощь")])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.scrolled) ? _c('li', {
    staticClass: "nav-item scroll-to-top-btn"
  }, [_c('a', {
    staticClass: "nav-link",
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.scrollToTopAction($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-up"
  }), _vm._v(" Наверх")])]) : _vm._e(), _vm._v(" "), (_vm.scrollToPrev && !_vm.scrolled) ? _c('li', {
    staticClass: "nav-item scroll-to-top-btn"
  }, [_c('a', {
    staticClass: "nav-link",
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.scrollToPrevAction($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-down"
  }), _vm._v(" Вернуться")])]) : _vm._e()])], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-351b5566", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-351b5566"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 1026
// module chunks = 1